/* @ngInject */
const LoginTokenRepository = function ($window, appTypeConfigurationModel, coreConstant) {
    this.getLoginToken = () => {
        let loginToken = $window.sessionStorage.getItem(appTypeConfigurationModel.appendConsoleType(coreConstant.authorization.LOCAL_STORAGE_LOGIN_TOKEN_KEY));

        return loginToken;
    };

    this.getLoginTokenAuthorizationHeader = () => {
        let loginToken = this.getLoginToken();
        if (loginToken) {
            return coreConstant.authorization.SCHEME + ' ' + loginToken;
        }
        return null;
    };

    this.setLoginToken = (loginToken) => {
        $window.sessionStorage.setItem(appTypeConfigurationModel.appendConsoleType(coreConstant.authorization.LOCAL_STORAGE_LOGIN_TOKEN_KEY), loginToken);
    };

    this.removeLoginToken = () => {
        $window.sessionStorage.removeItem(appTypeConfigurationModel.appendConsoleType(coreConstant.authorization.LOCAL_STORAGE_LOGIN_TOKEN_KEY));
    };
};

angular.module('gw-um-auth')
    .service('loginTokenRepository', LoginTokenRepository);
